import { IState } from 'legacy/lut/store'

export const selectPartnerFlags = (state: IState) => state.partner.partnerFlags
